import React from "react";
import PropTypes from "prop-types";
import BackIcon from '@material-ui/icons/ArrowBack';



import {primaryColor} from "../../assets/jss/material-dashboard-react";

import {
    withStyles,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
} from "@material-ui/core";

const styles={
    backButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    title:{
        flex:1
    },
    appBar:{
        backgroundColor:primaryColor
    }
}

class RouteHeader extends React.Component {

    goBack = () => {
        console.log("goBack:",this.props)


        const {history} = this.props
        history.goBack();
    };


    render(){
        const {classes,title} = this.props


        return(
            <AppBar className={classes.appBar} position="static">
                <Toolbar>
                    <IconButton onClick={this.goBack} className={classes.backButton} color="inherit" aria-label="Back">
                        <BackIcon />
                    </IconButton>
                    <Typography variant="title" color="inherit" className={classes.title}>
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>
        )
    }
}

export default withStyles(styles)(RouteHeader);


// WEBPACK FOOTER //
// ./src/components/RouteHeader/RouteHeader.jsx